<template>
<div class="chapter">
<div class="inner_page">
<h1 class="otherbooks">P<span class="small">RAISE FOR</span> D<span class="small">ON</span> W<span class="small">RIGHT</span></h1>
<div class="block">
<p class="nonindent">“Inspiring. Don Wright has the knack for writing stories based on real people that present a gritty, accurate, and inspiring portrait of those who endure and triumph—a testimony to the human spirit.”</p>
<p class="right">—<em>Romantic Times</em> on <em>Gone to Texas</em></p>
</div>
<div class="block">
<p class="nonindent">“Historical fiction of the first order….A ripsnorter, fast-paced and delightful from first page to last.”</p>
<p class="right">—<em>Chattanooga Times</em> on <em>The Woodsman</em></p>
</div>
<div class="block">
<p class="nonindent">“A breathtaking adventure of power and scope….A captivating wilderness adventure of love and courage during the French and Indian wars.”</p>
<p class="right">—<em>Publishers Weekly</em> on <em>The Woodsman</em></p>
</div>
<div class="block">
<p class="nonindent">“Marked by high adventure, strong characterizations, accurate historical background, and authentic knowledge of treacherous wilderness, the book is sure to take its place among the classic stories of the American frontier.”</p>
<p class="right">—<em>Nashville Banner</em> on <em>The Woodsman</em></p>
</div>
<div class="block">
<p class="nonindent">“Wright has woven old family rivalries and historical footnotes into a compelling and entertaining narrative….A thoroughly exciting adventure!”</p>
<p class="right">—<em>Publishers Weekly</em> on <em>The Captives</em></p>
</div>
<div class="block">
<p class="nonindent">“Good, clean, grisly fun, with scalps coming unstuck like Velero, arrows thwacking into bodies, and Morgan Patterson leading the charge.”</p>
<p class="right">—<em>Kirkus Reviews</em> on <em>The Captives</em></p>
</div>
<div class="block">
<p class="nonindent">“Engrossing, realistic, and very human…. Marvelous.”</p>
<p class="right">—<em>RAVE Reviews</em> on <em>The Last Plantation</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780812589085_epub_col_r1.vue?0e16cdf0